module.exports = __webpack_public_path__ + "static/media/gallery-2.5409e445.jpeg";